module.exports = __webpack_public_path__ + "static/media/Oneteam_white.68c09d18.svg";